export default function AddCommentForm (){
    return(
        <section className="ContactMeFormWrapper">
            <div className="title">Add Your Comment</div>
            <div className="sub-title">Share your thoughts, opinions, or suggestions in the comment section below. We value every contribution and respond with care and attention. We look forward to reading your comments with delight.</div>
            <div className="form-wrapper">
                <form>
                    <div className="row">
                        <div className="name">
                            <label htmlFor="fullname">full name</label>
                            <input type="text" id="fullname" placeholder="Input"></input>
                        </div>
                        <div className="email">
                            <label htmlFor="email">email</label>
                            <input type="email" id="email" placeholder="Input"></input>
                        </div>
                    </div>
                    <div className="row">
                        <div className="message">
                            <label htmlFor="comment">your comment</label>
                            <textarea id="comment" placeholder="Input"></textarea>
                        </div>
                    </div>
                    <div>
                        <button className="btn download-btn btn-icon" >Add Comment</button>
                    </div>
                </form>
                <span className="form-bubble bubble-1"></span>
                <span className="form-bubble bubble-2"></span>
            </div>
        </section>
    )
}